import React from "react";
import { Box, Typography } from "@mui/material";

const MediaGallery = ({ pictures = [], onImageClick }) => {
  return (
    <Box
      sx={{
        columnCount: { xs: 2, sm: 3, md: 4 },
        columnGap: 0.6,
        padding:1
      }}
    >
      {pictures.map((item, index) => (
        <Box
          key={index}
          sx={{
            breakInside: "avoid",
            mb: 0.6,
            borderRadius: 1,
            overflow: "hidden",
            cursor: "pointer",
          }}
          onClick={() => onImageClick(index)}
        >
          <img
            src={item.mediaName}
            alt={item.mediaTitle || `Picture ${index + 1}`}
            style={{
              width: "100%",
              height: "auto",
              display: "block",
              borderRadius: "4px",
            }}
          />
{/*           <Typography>
            {item.mediaTitle}
          </Typography>
 */}        </Box>
      ))}
    </Box>
  );
};

export default MediaGallery;
